'use client';

import clsx from 'clsx';
import { useRef } from 'react';
import FooterLinks from '../Links';
import useAccordion from '@/hooks/useAccordion';
import { CompanyLinks, CustomerSupportLinks, ShippingServiceLinks } from './constants';

import styles from './FooterNavigation.module.css';

const AccordionLink = ({ title, links }: any) => {
  const accordionContent = useRef<HTMLDivElement>(null);
  const { height, handleAccordionOpen, isShortListOpened } = useAccordion({
    shortListRef: accordionContent,
    isOpened: false,
    duration: 300,
  });

  return (
    <div className={styles.footerAccordion}>
      <div className={styles.accordionTitle} data-testid={'footer-accordion'} onClick={handleAccordionOpen}>
        <div>{title}</div>
        <span className={clsx({ [styles.down]: isShortListOpened.current }, styles.accordionIcon)}></span>
      </div>
      <div ref={accordionContent} style={{ height: height }} className={clsx(styles.accorionContent)}>
        <FooterLinks links={links} />
      </div>
    </div>
  );
};

const FooterNavigation = () => (
  <>
    <div className={styles.footerNavigationContainer}>
      <AccordionLink title="Customer Support" links={CustomerSupportLinks} />
      <AccordionLink title="Shopping Services" links={ShippingServiceLinks} />
      <AccordionLink title="Get To Know Us" links={CompanyLinks} />
    </div>

    <div className={styles.footerNavigation}>
      <div className={styles.footerNavigationSection}>
        <div className={styles.footerNavigationSectionTitle}>Customer Support</div>
        <FooterLinks links={CustomerSupportLinks} />
      </div>

      <div className={styles.footerNavigationSection}>
        <div className={styles.footerNavigationSectionTitle}>Shopping Services</div>
        <FooterLinks links={ShippingServiceLinks} />
      </div>

      <div className={styles.footerNavigationSection}>
        <div className={styles.footerNavigationSectionTitle}>Get To Know Us</div>
        <FooterLinks links={CompanyLinks} />
      </div>
    </div>
  </>
);

export default FooterNavigation;
